import { LoggedInOfficer } from '../models/logged-in-officer.models';

export function compareValuesLoggedInOfficerUid(previous: LoggedInOfficer, current: LoggedInOfficer): boolean {
  return previous.uid === current.uid;
}
